import React from "react";
//#region components
import RouteBreadCrumb from "./routeBreadCrumb";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const DashboardBreadCrumb: React.FC = () => {
  return <RouteBreadCrumb className={cssExports.dashBoardNavigation} />;
};

export default DashboardBreadCrumb;
